import { Input } from "@arcadeai/design-system/components/ui/atoms/input";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@arcadeai/design-system/rhf";
import type { UseFormReturn } from "react-hook-form";
import type { AuthProvider } from "@/app/oauth/types";

type Props = {
  form: UseFormReturn<AuthProvider>;
  canUpdate: boolean;
};

export const ClientIdField = ({ form, canUpdate }: Props) => (
  <FormField
    control={form.control}
    name="oauth2.client_id"
    render={({ field }) => (
      <FormItem>
        <FormLabel>Client ID</FormLabel>
        <FormControl>
          <Input placeholder="client-id" {...field} disabled={!canUpdate} />
        </FormControl>
        <FormMessage />
      </FormItem>
    )}
  />
);
